import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postAddUser = (params) => {
  return axiosClient
    .post(`api/admin/manageable-list/${params.id}/${params.userType}`, params)
    .then((r) => r.data);
};
